import React from 'react';
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
} from '@fluentui/react';
import { dialogModelProps } from '../../utils';

type Props = {
  hidden: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  title: string;
  subText?: string;
  confirmText?: string;
  cancelText?: string;
  confirmDisabled?: boolean;
};

const ConfirmDialog = ({
  hidden,
  onDismiss,
  onConfirm,
  title,
  subText,
  confirmText = 'Verwijderen',
  cancelText = 'Annuleren',
  confirmDisabled = false,
}: Props) => (
  <Dialog
    hidden={hidden}
    onDismiss={onDismiss}
    dialogContentProps={{
      type: DialogType.normal,
      title,
      subText,
      closeButtonAriaLabel: 'Sluiten',
    }}
    modalProps={dialogModelProps}
  >
    <DialogFooter>
      <PrimaryButton
        onClick={onConfirm}
        text={confirmText}
        disabled={confirmDisabled}
      />
      <DefaultButton
        onClick={onDismiss}
        text={cancelText}
        disabled={confirmDisabled}
      />
    </DialogFooter>
  </Dialog>
);

export default ConfirmDialog;
